import { createContext } from 'react';

const MediaContext = createContext(null);

export default MediaContext;
